import type { User as FirebaseUser } from 'firebase/auth';

export function createAppUser(firebaseUser: FirebaseUser) {
  return {
    id: Math.abs(hashCode(firebaseUser.uid)),
    firebase_uid: firebaseUser.uid,
    email: firebaseUser.email || '',
    display_name: firebaseUser.displayName,
    photo_url: firebaseUser.photoURL,
    preferred_language: 'en',
  };
}

export function createBasicSubscription() {
  const endDate = new Date();
  endDate.setFullYear(endDate.getFullYear() + 100);

  return {
    id: 2,
    status: 'active',
    end_date: endDate.toISOString(),
    plan: {
      name: 'Basic',
      name_ar: 'أساسي',
      question_limit: 20,
      has_full_access: 0,
      has_analytics: 0,
      has_priority_support: 0,
    },
    daysRemaining: null,
    isExpired: false,
  };
}

export function createTrialSubscription() {
  const endDate = new Date();
  endDate.setDate(endDate.getDate() + 10);

  return {
    id: 1,
    status: 'trial',
    end_date: endDate.toISOString(),
    plan: {
      name: 'Trial',
      name_ar: 'تجريبي',
      question_limit: null,
      has_full_access: 1,
      has_analytics: 1,
      has_priority_support: 0,
    },
    daysRemaining: 10,
    isExpired: false,
  };
}

function hashCode(value: string) {
  let hash = 0;
  for (let i = 0; i < value.length; i += 1) {
    hash = (hash << 5) - hash + value.charCodeAt(i);
    hash |= 0;
  }
  return hash || 1;
}
